import AccountSummary from '@advisor/models/store/accountDetails/AccountSummary';

export default class AccountDetails {
  constructor() {
    this.account = new AccountSummary();
    this.clientDetails = {
      segment: {
        id: null,
        label: null,
      },
    };
    this.roboStatus = 0;
  }
}
